'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = SimpleMap;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGoogleMaps = require('react-google-maps');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * This is the modify version of:
 * https://developers.google.com/maps/documentation/javascript/examples/event-arguments
 *
 * Add <script src="https://maps.googleapis.com/maps/api/js"></script> to your HTML to provide google.maps reference
 *
 * We use React 0.14 stateless function components here.
 * https://facebook.github.io/react/blog/2015/09/10/react-v0.14-rc1.html#stateless-function-components
 */
function SimpleMap(_ref) {
  var mapsCenter = _ref.mapsCenter,
      markers = _ref.markers,
      onMapClick = _ref.onMapClick,
      onMarkerRightclick = _ref.onMarkerRightclick;

  if (!mapsCenter) {
    return _react2.default.createElement('span', null);
  }

  return _react2.default.createElement(
    'section',
    { style: { height: '100%' } },
    _react2.default.createElement(_reactGoogleMaps.GoogleMapLoader, {
      containerElement: _react2.default.createElement('div', { style: {
          height: '100%'
        }
      }),
      googleMapElement: _react2.default.createElement(
        _reactGoogleMaps.GoogleMap,
        {
          defaultZoom: 15,
          center: mapsCenter,
          options: {
            draggable: false,
            disableDoubleClickZoom: true,
            scrollwheel: false,
            zoomControl: true
          },
          onClick: onMapClick
        },
        markers.map(function (marker, index) {
          return _react2.default.createElement(_reactGoogleMaps.Marker, (0, _extends3.default)({}, marker, {
            onRightclick: function onRightclick() {
              return onMarkerRightclick(index);
            }
          }));
        })
      )
    })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SimpleMap.js
// module id = 2243
// module chunks = 0